import styled, { css } from 'styled-components';
import { Chart } from '../../../../ui/atoms/CircularStats/style';

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 24px;
  margin-bottom: 16px;

  @media ${(props) => props.theme.device.tabletL} {
    display: flex;
    flex-direction: column;
    row-gap: 32px;
    margin-bottom: 24px;
  }
`;

export const InfoBox = styled.div`
  display: flex;
  padding: 20px 24px;
  background-color: ${({ theme }) => theme.colors.bgBox};
  border-radius: 8px;
  gap: 50px;
`;

export const InfoBoxMobile = styled.div`
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.bgBox};
  border-radius: 8px;
  display: flex;
  column-gap: 24px;
`;

export const Card = styled.div`
  padding: 16px;
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  margin-bottom: 48px;

  .filters-wrapper {
    margin-top: 8px;
    display: flex;
    align-items: center;
    column-gap: 24px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    display: flex;
    flex-direction: column;

    .filters-wrapper {
      margin-top: 16px;
      margin-bottom: 32px;
      flex-direction: column;
      align-items: flex-start;
      row-gap: 8px;
    }
  }
`;

export const ChartsWrapper = styled.div`
  display: flex;
  margin-bottom: 32px;

  .chart-container {
    margin-top: 24px;
    min-height: 145px;
    border-right: 2px dashed ${({ theme }) => theme.colors.border};
    margin-right: 36px;
    padding-right: 36px;

    > div {
      max-width: calc(100% - 130px - 16px * 2 - 16px);
      //? 130px (chart) 16px*2 (bubbles) 16px (gap)
    }

    &.last {
      margin-right: 0;
      padding-right: 0;
      border-right: none;
    }
  }
  .chart-wrapper {
    position: relative;
    right: 80px;
  }

  @media ${(props) => props.theme.device.tabletL} {
    flex-direction: column;

    .chart-container {
      margin-right: 0;
      padding-right: 0;
      border: none;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    order: 2;

    .chart-container {
      min-height: 300px;
      flex-direction: column;
      align-items: flex-start;

      > div {
        max-width: unset;
      }
    }

    .chart-wrapper {
      position: relative;
      left: 50%;
      height: 190px;
    }

    ${Chart} {
      top: unset;
      bottom: unset;
      right: unset;
      width: unset;
      transform: translate(-50%, 0%);
    }
  }
`;

export const RefreshAndLegend = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${(props) => props.theme.device.tabletL} {
    flex-direction: column-reverse;
    row-gap: 24px;
  }
`;

export const ChartLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 24px;
  row-gap: 8px;

  @media ${(props) => props.theme.device.mobileL} {
    order: 1;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  }
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`;

export const ColorBox = styled.div`
  width: 20px;
  height: 11px;
  flex-shrink: 0;
  border-radius: 3px;
  background: ${({ color }) => color};
  //? prevent background from being ignored @print
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
`;

export const FiltersWrapper = styled.div`
  margin: 32px 0 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;

  #filter-groups {
    order: 1;
  }

  #filter-categories {
    order: 2;
  }

  #filter-ffoo {
    order: 3;
  }

  #filter-publication_date {
    order: 4;
  }

  #filter-published {
    order: 5;
  }
`;

export const SortingWrapper = styled.div`
  margin-block: 24px;
  display: flex;
  align-items: baseline;

  > div {
    height: 48px;
  }
`;

const gridTableCol = css`
  --padding-inline: 32px;

  display: grid;
  grid-template-columns: 1fr 2fr 1fr 1fr 1fr 1fr 1fr 120px;
  gap: 24px;
  padding-inline: var(--padding-inline);
`;

export const Legend = styled.div`
  ${gridTableCol}
  margin-bottom: 16px;

  > *:first-child {
    margin-left: calc(var(--padding-inline) * -1);
  }

  > *:last-child {
    margin-right: calc(var(--padding-inline) * -1);
  }
`;

export const CardsWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['hasPaginator'].includes(prop),
})`
  padding-bottom: ${({ hasPaginator }) => (hasPaginator ? 32 : 64)}px;

  > div:last-child {
    margin-bottom: 0;
  }
`;

export const CourseCard = styled.div`
  ${gridTableCol}
  height: 100px;
  align-items: center;
  margin-bottom: 16px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  color: ${({ theme }) => theme.colors.primaryDarkGray700};

  .typology {
    border-left: 1px solid;
    padding-left: 8px;
    line-height: 16px;
    margin-bottom: 8px;
  }
`;
